import Chart from './Model/Chart';
import TooltipPlugin from './Plugins/TooltipPlugin';
import ZoomPlugin from './Plugins/ZoomPlugin';

requirejs(['jquery'], function($) {
    $('[data-chart]').each(function(){
        const dom = $(this)[0];
        const chart = new Chart(dom, 575, 170, {
            top: 25,
            right: 25,
            bottom: 25,
            left: 40
        });
        chart.addPlugin(new TooltipPlugin);
        chart.addPlugin(new ZoomPlugin);

        $( window ).resize(function() {
            chart.updateDimensions();
        });
    });
});


// WEBPACK FOOTER //
// ./js/charts.js